

import { Component, Mixins, Prop } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Line, mixins } from 'vue-chartjs';
import colors from 'vuetify/es5/util/colors';

@Component
export default class LineBar5 extends Mixins(Line) {
  @Prop(String) public height!: string;
  // グラフ用のデータ
  private name = 'LineChart';
  private chartData: Chart.ChartData = {
    labels: ['5/1', '5/5', '5/9', '5/13', '5/17', '5/21', '5/25', '5/29'],
    datasets: [
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(252, 79, 168, 0.3)',
        borderColor: 'rgba(252, 79, 168, 0.5)',
        pointBackgroundColor: 'rgba(252, 79, 168, 1)',
        // Data to be represented on y-axis
        data: [160, 158, 155, 140, 121, 100, 99],
        fill: false
        // ベジェ曲線のテンション(張力)
        // lineTension: 0.2
      },
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(76, 132, 253, 0.3)',
        borderColor: 'rgba(76, 132, 253, 0.5)',
        pointBackgroundColor: 'rgba(76, 132, 253, 1)',
        // Data to be represented on y-axis
        data: [160, 140, 120, 100, 80, 60, 40, 20, 0],
        // ベジェ曲線のテンション(張力)
        // lineTension: 4
        fill: false
      },
    ],
  };
  private options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {display: false, fullWidth: false, reverse: false, rtl: false},
    tooltips: { enabled: false },
    plugins: {
    datalabels: {
         // hide datalabels for all datasets
        display: false
      },
    },
    scales: {
      // 軸設定
      xAxes: [
        // Ｘ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示設定
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0)', // 補助線の色
          },
          ticks: {
            // 目盛り
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
      yAxes: [
        // Ｙ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示の有無
            // フォントサイズ
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0.08)', // 補助線の色
          },
          ticks: {
            // 目盛り
            min: 0, // 最小値
            max: 180, // 最大値
            stepSize: 30, // 軸間隔
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
    },
  };

  public mounted() {
    // グラフを描画
    this.renderChart(this.chartData, this.options);
  }
}
